import './index.less'
import { getOldInviteNewConfig, getOldReferInfo, createReferLink, sendInviteEmail, } from "@utils/api.js"
import { isiOS, copyString, } from "@utils/index.js"

export default class OldInviteNewBanner {
  constructor() {
    this.skeletonWrap = document.querySelector('.old-invite-new-skeleton-wrap')
    this.bannerWrap = document.querySelector('.old-invite-new-banner-wrap')

    this.myRewardsBtn = document.querySelector('[data-old-invite-new-my-rewards]')

    // 配置数据
    this.configData = Object.create(null)
    this.olderEmail = '' // 老客邮箱，初始值为空

    if (this.skeletonWrap && this.bannerWrap) {
      // 主副标题 DOM
      this.titleDOM = this.bannerWrap.querySelector('[data-old-invite-new-banner-title]')
      this.subtitleDOM = this.bannerWrap.querySelector('[data-old-invite-new-banner-subtitle]')
      this.formDOM = this.bannerWrap.querySelector('[data-old-invite-new-form]')
      this.shareDOM = this.bannerWrap.querySelector('[data-old-invite-new-share]')

      this.init()
    }

    // My Rewards 按钮点击
    if (this.myRewardsBtn) {
      this.myRewardsBtn.onclick = (e) => {
        const target = e.target.tagName === 'SPAN' ? e.target.parentElement : e.target
        const { rewardTitle, buttonText, } = target.dataset

        const link = `${window.pageInfo.account_url}/account/referral`
        // 已登录
        if (window?.pageInfo?.customerInfo?.id) {
          // 数据埋码
          this.GAEvent({
            module: rewardTitle || 'My Rewards',
            button_name: buttonText,
            status: window?.pageInfo?.customerInfo?.id ? 'logged_in' : 'tourist',
          })

          // 因为苹果的安全机制拦截了，所以不能打开新的标签页
          isiOS()
            ? (window.location.href = `${link}?cr=${window.pageInfo.cr}`)
            : window.open(`${link}?cr=${window.pageInfo.cr}`, '_blank')
        }
        // 未登录
        else {
          // 数据埋码
          this.GAEvent({
            module: rewardTitle || 'My Rewards',
            button_name: buttonText,
            status: window?.pageInfo?.customerInfo?.id ? 'logged_in' : 'tourist',
          })

          window?.jackeryLoginApp?.modalLogin({
            return_url: link,
            register_act: 'ReferOld-Register',
          })
        }
      }
    }
  }
  async init() {
    // Section DOM
    const sectionDOM = this.skeletonWrap?.parentElement || this.bannerWrap?.parentElement
    if (sectionDOM) {
      this.observe(sectionDOM)
    }

    try {
      const { data } = await getOldInviteNewConfig()

      if (data) {
        this.configData = data

        // 渲染 banner
        this.bannerWrap.querySelector('[data-banner-img-pc]').src = this.configData.bannerUrl
        this.bannerWrap.querySelector('[data-banner-img-mb]').src = this.configData.mbBannerUrl
        
        // 已登录
        if (window?.pageInfo?.customerInfo?.id) {
          // 赋值 老客邮箱
          this.olderEmail = window.pageInfo.customerInfo.email

          // 获取老客邀请链接
          const infoData = await getOldReferInfo({ email: this.olderEmail, })

          // 隐藏 骨架屏
          this.skeletonWrap?.parentElement?.removeChild(this.skeletonWrap)
          // 显示 内容
          this.bannerWrap.classList.remove('!hidden')

          // 如果 有 邀请链接
          if (infoData?.data?.referLink) {
            this.renderShareDOM(infoData.data.referLink)
          }
          // 无邀请链接
          else {
            this.titleDOM.querySelector('span').innerText = this.configData.loginTitle
            this.subtitleDOM.querySelector('span').innerText = this.configData.loginDesc

            this.formDOM.classList.remove('!hidden')

            // 自动填入用户 email
            this.formDOM.querySelector('input').value = this.olderEmail

            this.registerFormButton(this.configData.loginButtonDesc, infoData?.data?.subscribeStatus)

            // 如果未订阅
            if (!infoData?.data?.subscribeStatus) {
              const labelDOM = this.formDOM.querySelector('label')
              this.renderPolicyDOM(labelDOM)
            }
          }
        }
        // 未登录
        else {
          // 隐藏 骨架屏
          sectionDOM?.removeChild(this.skeletonWrap)
          // 显示 内容
          this.bannerWrap.classList.remove('!hidden')

          this.titleDOM.querySelector('span').innerText = this.configData.notLoginTitle
          this.subtitleDOM.querySelector('span').innerText = this.configData.notLoginDesc

          this.formDOM.classList.remove('!hidden')

          this.registerFormButton(this.configData.notLoginButtonDesc, false)
        }
      } else {
        // 隐藏 骨架屏
        sectionDOM?.removeChild(this.skeletonWrap)
        // 隐藏 banner
        sectionDOM?.removeChild(this.bannerWrap)
      }
    } catch(err) {
      // 隐藏 骨架屏
      sectionDOM?.removeChild(this.skeletonWrap)
      // 隐藏 banner
      sectionDOM?.removeChild(this.bannerWrap)
    }
  }

  // 注册 表单按钮
  registerFormButton(buttonText, subscribeStatus) {
    const inputDOM = this.formDOM.querySelector('[data-old-invite-new-form-input]')
    const buttonDOM = this.formDOM.querySelector('[data-old-invite-new-form-button]')
    const labelDOM = this.formDOM.querySelector('label')
    const emailErrorTip = this.formDOM.querySelector('[data-email-error-tip]')
    const policyErrorTip = this.formDOM.querySelector('[data-policy-error-tip]')

    const { emailEmptyErrorText, emailFormatErrorText, } = this.bannerWrap.dataset

    buttonDOM.querySelector('span').innerText = buttonText

    // input change
    inputDOM.addEventListener('input', (e) => emailErrorTip.classList.add('hidden'))
    labelDOM.querySelector('input[type="checkbox"]').addEventListener('change', (e) => policyErrorTip.classList.add('hidden'))

    this.formDOM.addEventListener('submit', async (e) => {
      e.preventDefault()

      buttonDOM.classList.add('btn--loading')
      this.olderEmail = inputDOM.value
      if (!this.olderEmail.trim()) {
        emailErrorTip.innerText = emailEmptyErrorText
        emailErrorTip.classList.remove('hidden')

        buttonDOM.classList.remove('btn--loading')
        return false
      }
      if (!/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(this.olderEmail)) {
        emailErrorTip.innerText = emailFormatErrorText
        emailErrorTip.classList.remove('hidden')
        
        buttonDOM.classList.remove('btn--loading')
        return false
      }

      // 已订阅
      if (subscribeStatus) {
        // 生成 邀请链接
        await this.handleCreateReferLink(this.olderEmail, buttonText)

        buttonDOM.classList.remove('btn--loading')
      } else {
        // 如果 checkbox 未显示
        if (labelDOM.classList.contains('!hidden')) {
          // 获取老客邀请链接
          const infoData = await getOldReferInfo({ email: this.olderEmail, })

          // 如果 有 邀请链接
          if (infoData.data.referLink) {
            buttonDOM.classList.remove('btn--loading')

            // 数据埋码
            this.GAEvent({
              module: this.titleDOM.querySelector('span').innerText || 'First login',
              position: buttonText,
              status: window?.pageInfo?.customerInfo?.id ? 'logged_in' : 'tourist',
            })

            this.renderShareDOM(infoData.data.referLink, 300)
          }
          // 无邀请链接
          else {
            // 如果未订阅
            if (!infoData?.data?.subscribeStatus) {
              this.renderPolicyDOM(labelDOM)

              buttonDOM.classList.remove('btn--loading')
            }
            // 如果已订阅
            else {
              // 生成 邀请链接
              await this.handleCreateReferLink(this.olderEmail, buttonText)

              buttonDOM.classList.remove('btn--loading')
            }
          }
        }
        // 如果 checkbox 已显示，或者已订阅
        else {
          const isChecked = labelDOM.querySelector('#old-invite-new-agree-checkbox').checked
          if (!isChecked) {
            policyErrorTip.innerText = labelDOM.dataset.policyErrorText
            policyErrorTip.classList.remove('hidden')

            buttonDOM.classList.remove('btn--loading')
            return false
          }

          // 生成 邀请链接
          await this.handleCreateReferLink(this.olderEmail, buttonText)
          
          buttonDOM.classList.remove('btn--loading')
        }
      }
    })
  }
  // 生成 邀请链接
  async handleCreateReferLink(email, buttonText) {
    const createData = await createReferLink({ email, })
    if (createData.data) {
      // 数据埋码
      this.GAEvent({
        module: this.titleDOM.querySelector('span').innerText || 'First login',
        position: buttonText,
        status: window?.pageInfo?.customerInfo?.id ? 'logged_in' : 'tourist',
      })

      this.renderShareDOM(createData.data, 300)
    }
  }
  // 渲染政策 DOM
  renderPolicyDOM(labelDOM) {
    labelDOM.classList.remove('!hidden')

    const spanDOM = labelDOM.querySelector('span')
    const { terms_service, terms_service_url, privacy_policy, privacy_policy_url, } = spanDOM.dataset
    let spanHTML = spanDOM.innerHTML

    const termsServiceHtml = `<a href="${terms_service_url}" target="_blank" class="text-#666 hover:text-primary underline underline-offset-4">${terms_service}</a>`
    const privacyPolicyHtml = `<a href="${privacy_policy_url}" target="_blank" class="text-#666 hover:text-primary underline underline-offset-4">${privacy_policy}</a>`

    spanHTML = spanHTML.replace('{termsService}', termsServiceHtml)
    spanHTML = spanHTML.replace('{PrivacyPolicy}', privacyPolicyHtml)
    spanDOM.innerHTML = spanHTML
  }
  // 渲染 分享DOM
  renderShareDOM(shareLink, hiddenImgTime = 0) {
    this.titleDOM.querySelector('span').innerText = this.configData.generatedTitle
    this.titleDOM.classList.remove('lg:j-text-40', 'lg:j-leading-50', 'lg:j-h-152', 'xl:a-text-40', 'xl:a-leading-50', 'xl:a-h-152')
    this.titleDOM.classList.add('lg:j-text-32', 'lg:j-leading-40', 'lg:j-h-134', 'xl:a-text-32', 'xl:a-leading-40', 'xl:a-h-134')

    this.subtitleDOM.classList.remove('lg:j-h-104', 'lg:j-mt-25', 'xl:a-h-104', 'xl:a-mt-25')
    this.subtitleDOM.classList.add('lg:j-h-160', 'lg:j-mt-15', 'xl:a-h-160', 'xl:a-mt-15')
    this.subtitleDOM.querySelector('span').innerText = this.configData.generatedDesc
    this.subtitleDOM.querySelector('span').classList.remove('lg:line-clamp-4')
    this.subtitleDOM.querySelector('span').classList.add('lg:line-clamp-6')

    this.shareDOM.classList.remove('!hidden')
    this.formDOM.classList.add('!hidden')

    // 显示分享链接
    this.shareDOM.querySelector('[data-old-invite-new-share-link]').innerText = shareLink
    this.shareDOM.querySelector('[data-old-invite-new-media-desc]').innerText = this.configData.generatedMediaDesc

    // 渲染 社媒分享 icon
    this.renderShareMediaIcons(shareLink)

    // 注册 copy 事件
    this.shareDOM.querySelector('[data-old-invite-new-copy]').onclick = (e) => {
      e.target.setAttribute('disabled', 'disabled')

      const { copyText, copiedText, copySuccessTip, } = e.target.dataset
      copyString(shareLink, () => {
        // 提示 copy 成功
        pushSuccessMessage(copySuccessTip)
        e.target.innerText = copiedText

        setTimeout(() => {
          e.target.innerText = copyText
          e.target.removeAttribute('disabled')
        }, 3000)

        // 数据埋码
        this.GAEvent({
          module: this.titleDOM.querySelector('span').innerText || 'Invitation',
          content: 'Copy Link',
          position: copyText,
          status: window?.pageInfo?.customerInfo?.id ? 'logged_in' : 'tourist',
        })
      })
    }

    // Mobile 端，不需要展示头图
    setTimeout(() => {
      const bannerImgContainer = this.bannerWrap?.querySelector('.old-invite-new-banner-img-container')
      if (bannerImgContainer) {
        bannerImgContainer.classList.remove('max-h-480')
        bannerImgContainer.classList.add('max-h-0')
      }
    }, hiddenImgTime)
  }
  // 渲染社媒Icons
  renderShareMediaIcons(shareLink) {
    const shareMediaWrap = this.bannerWrap.querySelector('[data-old-invite-new-share-icons]')
    shareMediaWrap.querySelectorAll('[data-type]').forEach(item => {
      const type = item.dataset.type
      const medias = this.configData.medias.map(({ media, }) => media)
      if (medias.includes(type)) {
        item.classList.remove('!hidden')

        item.onclick = () => {
          if (type === 'email') {
            this.handleEmailClick(shareMediaWrap.dataset.emailPlaceholder)

            // 数据埋码
            this.GAEvent({
              module: this.titleDOM.querySelector('span').innerText,
              content: 'Social Share',
              position: 'Email',
              status: window?.pageInfo?.customerInfo?.id ? 'logged_in' : 'tourist',
            })
          } else {
            const content = this.configData.medias.find(({ media, }) => media === type)?.mediaDesc
            const shareUrl = this.getSocialShareAPI(shareLink, type, content)
            // instagram
            if (type === 'instagram') {
              copyString(shareLink, () => {
                // 提示 copy 成功
                pushSuccessMessage(shareMediaWrap.dataset.instagramCopySuccessTip)

                // 数据埋码
                this.GAEvent({
                  module: this.titleDOM.querySelector('span').innerText,
                  content: 'Social Share',
                  position: type,
                  status: window?.pageInfo?.customerInfo?.id ? 'logged_in' : 'tourist',
                })
        
                setTimeout(() => {
                  window.open('https://www.instagram.com/', '_blank')
                }, 3000)
              })
            }
            // whatsapp 不支持小窗打开
            else if (type === 'whatsapp') {
              // 数据埋码
              this.GAEvent({
                module: this.titleDOM.querySelector('span').innerText,
                content: 'Social Share',
                position: type,
                status: window?.pageInfo?.customerInfo?.id ? 'logged_in' : 'tourist',
              })

              window.open(shareUrl, '_blank')
            }
            // 小窗打开
            else {
              let popWidth = 600,
                  popHeight = 480,
                  left = window.innerWidth / 2 - popWidth / 2 + window.screenX,
                  top = window.innerHeight / 2 - popHeight / 2 + window.screenY,
                  popParams = `scrollbars=no, width=${popWidth}, height=${popHeight}, top=${top}, left=${left}`,
                  newWindow = window.open(shareUrl, '', popParams)

              if (window.focus) {
                newWindow.focus()
              }

              // 数据埋码
              this.GAEvent({
                module: this.titleDOM.querySelector('span').innerText,
                content: 'Social Share',
                position: type,
                status: window?.pageInfo?.customerInfo?.id ? 'logged_in' : 'tourist',
              })
            }
          }
        }
      }
    })
  }
  // 邮箱弹窗内容
  renderEmailPopup(emailPlaceholder) {
    return `
      <h2 class="w-full font-semibold text-center text-#1A1A1A text-40 leading-48 lg:j-text-32 lg:j-leading-44 xl:a-text-32 xl:a-leading-44">
        ${this.configData.emailTitle}
      </h2>
      <form class="w-full flex bg-white border-solid border-#DEDEDE mt-32 h-80 rounded-6 border-1 lg:j-h-48 lg:j-rounded-24 lg:j-border-1 lg:j-mt-25 xl:a-h-48 xl:a-rounded-24 xl:a-border-1 xl:a-mt-25">
        <input class="appearance-none flex-1 w-full h-full font-medium rounded-6 px-20 text-center text-28 lg:text-left lg:h-full lg:j-px-20 lg:j-rounded-24 lg:j-text-16 xl:a-px-20 xl:a-rounded-24 xl:a-text-16" placeholder="${emailPlaceholder}" type="text">
        <button type="submit" class="hidden lg:flex flex-center old-invite-new-button old-invite-new-highlight-button appearance-none h-full lg:j-min-w-120 lg:j-rounded-24 lg:j-text-16 xl:a-min-w-120 xl:a-rounded-24 xl:a-text-16">
          <span class="line-clamp-1">${this.configData.emailButtonDesc}</span>
        </button>
      </form>

      <p class="hidden w-full text-#FE3B30 font-normal text-28 leading-32 mt-12 lg:j-mt-8 lg:j-text-14 lg:j-leading-24 xl:a-mt-8 xl:a-text-14 xl:a-leading-24" data-email-popup-error-tip></p>

      <div class="w-full text-black font-medium h-260 px-20 py-15 mt-32 border-1 border-solid border-#999 lg:border-#D8D8D8 rounded-6 lg:j-h-150 lg:j-p-16 lg:j-mt-32 lg:j-text-14 lg:j-leading-22 lg:j-border-1 lg:j-rounded-5 xl:a-h-150 xl:a-p-16 xl:a-mt-32 xl:a-text-14 xl:a-leading-22 xl:a-border-1 xl:a-rounded-5 overflow-y-auto">
        ${this.configData.emailContent}
      </div>

      <button data-old-invite-new-email-mb-btn class="flex-center lg:hidden appearance-none max-w-full h-80 min-w-326 rounded-40 text-white bg-primary font-semibold mt-32">
        <span class="line-clamp-1">${this.configData.emailButtonDesc}</span>
      </button>

      <div class="w-full lg:text-black font-normal text-#666 text-26 leading-38 mt-32 lg:j-mt-16 lg:j-text-14 lg:j-leading-22 xl:a-mt-16 xl:a-text-14 xl:a-leading-22">
        ${this.configData.emailRemark}
      </div>
    `
  }
  handleEmailClick(emailPlaceholder) {
    const popupHtml = this.renderEmailPopup(emailPlaceholder)
    window.ZModle.getInstance(popupHtml, {
      id: `old-invite-new-email-popup`,
      class: "old-invite-new-email-popup-wrap",
      cb: (modal) => {
        const formDOM = modal.querySelector('form')
        const inputDOM = formDOM.querySelector('input')
        const buttonDOM = formDOM.querySelector('button')
        const mbButtonDOM = modal.querySelector('[data-old-invite-new-email-mb-btn]')
        const emailErrorTip = modal.querySelector('[data-email-popup-error-tip]')

        const { emailFormatErrorText, emailMessageSent, } = this.bannerWrap.dataset

        const submit = async (e) => {
          e.preventDefault()

          buttonDOM.classList.add('btn--loading')
          mbButtonDOM.classList.add('btn--loading')
          const newerEmail = inputDOM.value
          if (!newerEmail.trim()) {
            emailErrorTip.innerText = emailPlaceholder
            emailErrorTip.classList.remove('hidden')

            buttonDOM.classList.remove('btn--loading')
            mbButtonDOM.classList.remove('btn--loading')
            return false
          }
          if (!/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(newerEmail)) {
            emailErrorTip.innerText = emailFormatErrorText
            emailErrorTip.classList.remove('hidden')
            
            buttonDOM.classList.remove('btn--loading')
            mbButtonDOM.classList.remove('btn--loading')
            return false
          }

          try {
            // 生成 邀请链接
            const { data, message, } = await sendInviteEmail({ olderEmail: this.olderEmail, newerEmail, })

            if (data) {
              pushSuccessMessage(emailMessageSent)
            } else {
              pushErrorMessage(message)
            }

            // 数据埋码
            this.GAEvent({
              module: this.configData.emailTitle || 'Invitation',
              content: 'Send Email Success',
              position: 'Email',
              button_name: this.configData.emailButtonDesc,
              status: window?.pageInfo?.customerInfo?.id ? 'logged_in' : 'tourist',
            })
          } catch(err) {
            pushErrorMessage(err.message)
          } finally {
            buttonDOM.classList.remove('btn--loading')
            mbButtonDOM.classList.remove('btn--loading')
            inputDOM.value = ''
          }
        }

        // input change
        inputDOM.addEventListener('input', (e) => emailErrorTip.classList.add('hidden'))
        formDOM.addEventListener('submit', (e) => submit(e))
        mbButtonDOM.addEventListener('click', (e) => submit(e))
      }
    })
  }

  // 各社交平台分享插件调用
  getSocialShareAPI(pageShareUrl, type, content) {
    let url = '';
    switch (type) {
      case 'facebook':
        url = 'https://www.facebook.com/sharer.php?u=' + encodeURIComponent(pageShareUrl);
        break;
      case 'twitter':
        url = `https://twitter.com/intent/tweet?original_referer=${encodeURIComponent(pageShareUrl)}&ref_src=${encodeURIComponent('twsrc^tfw|twcamp^buttonembed|twterm^share|twgr^')}&text=${encodeURIComponent(content)}&url=${encodeURIComponent(`${pageShareUrl}`)}`;
        break;
      case 'whatsapp':
        url = `https://api.whatsapp.com/send?text=${content} ${encodeURIComponent(pageShareUrl)}`;
        break;
      case 'line':
        url = `http://line.me/R/msg/text/?${encodeURIComponent(content)} ${pageShareUrl}`
        break;
      case 'telegram':
        url = `https://t.me/share/url?url=${encodeURIComponent(`${pageShareUrl}`)}&text=${content}`;
        break;
      default:
        url = '';
        break;
    }
    return url;
  }

  // 数据埋码
  GAEvent(params) {
    window.dataLayer.push({ "event_parameters": null });
    window.dataLayer.push({
      "event":"ga4Event",
      "event_name":"refer_new_user_clicks",
      "event_parameters":{
        "current_page": window.location.href, // current page url
        ...params
      }
    });
  }

  // 出场动画
  observe(sectionDOM) {
    const Observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('active')
        }
      })
    }, {
      root: null,
      rootMargin: '0px',
      threshold: 0.2,
    })

    const targetDOMs = sectionDOM?.querySelectorAll('[data-animation-dom]')
    if (targetDOMs.length > 0) {
      targetDOMs.forEach(it => Observer.observe(it))
    }
  }
}
